var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"content-class":"documentMenuClass"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var btn = ref.btn;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"documentButton",attrs:{"id":_vm.id,"text":"","disabled":!_vm.enable}},'v-btn',btn,false),on),[_c('v-icon',{attrs:{"color":"primary","left":""}},[_vm._v(" "+_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.$t(("" + _vm.text)))+" ")],1)]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }